import { render, staticRenderFns } from "./full-status.vue?vue&type=template&id=528b1670&scoped=true"
import script from "./full-status.vue?vue&type=script&lang=js"
export * from "./full-status.vue?vue&type=script&lang=js"
import style0 from "./full-status.vue?vue&type=style&index=0&id=528b1670&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "528b1670",
  null
  
)

export default component.exports